import Vue from 'vue'
import App from './App.vue'
import router from './router'

import '@/assets/main.scss'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faFacebookSquare, faInstagram } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope, faHouse, faPhone, faFile, faPaperPlane } from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faFacebookSquare, faFile, faPaperPlane, faInstagram, faPhone, faEnvelope, faHouse, faPhone)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
